export default __webpack_public_path__ + "static/lonely-planet-globe-tripper-fff9c76eeb253c224119e703e7c4c8d7.svg";